"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lot_1 = require("./lot");

var pagination_1 = require("./pagination");

var class_validator_1 = require("class-validator");

var promoter_1 = require("./promoter");

var class_transformer_1 = require("class-transformer");

var country_1 = require("./country");

var ProgramPublicDTO = function ProgramPublicDTO() {
  _classCallCheck(this, ProgramPublicDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "street", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], ProgramPublicDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "liveSelection", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "investSelection", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "reducedVat", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "closeToParis", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "pinel", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "profitability", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "greaterParis", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), __metadata("design:type", Object)], ProgramPublicDTO.prototype, "coordinates", void 0);

__decorate([class_transformer_1.Type(function () {
  return promoter_1.PromoterPublicDTO;
}), class_validator_1.IsOptional(), __metadata("design:type", promoter_1.PromoterPublicDTO)], ProgramPublicDTO.prototype, "promoter", void 0);

__decorate([class_validator_1.IsUrl({}, {
  each: true
}), __metadata("design:type", Array)], ProgramPublicDTO.prototype, "pictures", void 0);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", Date)], ProgramPublicDTO.prototype, "finishDate", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "plan", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "booklet", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "slug", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPublicDTO.prototype, "enableCityScan", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramPublicDTO.prototype, "externalId", void 0);

exports.ProgramPublicDTO = ProgramPublicDTO;

var ProgramPrivateDTO =
/*#__PURE__*/
function (_ProgramPublicDTO) {
  _inherits(ProgramPrivateDTO, _ProgramPublicDTO);

  function ProgramPrivateDTO() {
    _classCallCheck(this, ProgramPrivateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgramPrivateDTO).apply(this, arguments));
  }

  return ProgramPrivateDTO;
}(ProgramPublicDTO);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", Date)], ProgramPrivateDTO.prototype, "deleteDate", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramPrivateDTO.prototype, "locked", void 0);

exports.ProgramPrivateDTO = ProgramPrivateDTO;

var ProgramCreationDTO = function ProgramCreationDTO() {
  _classCallCheck(this, ProgramCreationDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "street", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.NotContains('&'), __metadata("design:type", String)], ProgramCreationDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), __metadata("design:type", String)], ProgramCreationDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsDateString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "finishDate", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "liveSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "investSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "reducedVat", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "closeToParis", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "pinel", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "profitability", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramCreationDTO.prototype, "greaterParis", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Object)], ProgramCreationDTO.prototype, "coordinates", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "promoterId", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramCreationDTO.prototype, "externalId", void 0);

exports.ProgramCreationDTO = ProgramCreationDTO;

var ProgramSearchDTO =
/*#__PURE__*/
function (_ProgramPublicDTO2) {
  _inherits(ProgramSearchDTO, _ProgramPublicDTO2);

  function ProgramSearchDTO() {
    _classCallCheck(this, ProgramSearchDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgramSearchDTO).apply(this, arguments));
  }

  return ProgramSearchDTO;
}(ProgramPublicDTO);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "surfaceMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "surfaceMax", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "priceMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "priceMax", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "roomsCountMin", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], ProgramSearchDTO.prototype, "roomsCountMax", void 0);

__decorate([class_validator_1.IsUrl(), __metadata("design:type", String)], ProgramSearchDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsEnum(lot_1.PinelZones), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramSearchDTO.prototype, "pinelZone", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], ProgramSearchDTO.prototype, "zeroLoan", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], ProgramSearchDTO.prototype, "externalId", void 0);

exports.ProgramSearchDTO = ProgramSearchDTO;

var ProgramUpdateDTO = function ProgramUpdateDTO() {
  _classCallCheck(this, ProgramUpdateDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "description", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "street", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.NotContains('&'), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "country", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "finishDate", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "liveSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "investSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "reducedVat", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "closeToParis", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "pinel", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "profitability", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "greaterParis", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Object)], ProgramUpdateDTO.prototype, "coordinates", void 0);

__decorate([class_validator_1.IsDateString(), class_validator_1.IsOptional(), __metadata("design:type", Date)], ProgramUpdateDTO.prototype, "deleteDate", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "bookletId", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "planId", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramUpdateDTO.prototype, "newPictureId", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramUpdateDTO.prototype, "locked", void 0);

exports.ProgramUpdateDTO = ProgramUpdateDTO;

var ProgramFilterDTO = function ProgramFilterDTO() {
  _classCallCheck(this, ProgramFilterDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "cityInclude", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "department", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "departmentCode", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsEnum(country_1.Country), class_validator_1.IsOptional(), __metadata("design:type", Array)], ProgramFilterDTO.prototype, "countries", void 0);

__decorate([class_validator_1.IsEnum(lot_1.FiscalTools), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "fiscalTool", void 0);

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), class_validator_1.IsOptional(), __metadata("design:type", Array)], ProgramFilterDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "minPrice", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "maxPrice", void 0);

__decorate([class_validator_1.IsEnum(lot_1.LotTypes), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "minSurface", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "maxSurface", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "delivery", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "liveSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "investSelection", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "reducedVat", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "closeToParis", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "pinel", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "profitability", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "greaterParis", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "invest", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "withLocations", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "withPromoters", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "allowEmptyPrograms", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "discardMinPrice", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "allowDisabledPromoters", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "monthlyComplementaryIncome", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "annualTaxSaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "monthlySaving", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "monthlySavingDuration", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "latitude", void 0);

__decorate([class_validator_1.IsNumber(), class_validator_1.IsOptional(), __metadata("design:type", Number)], ProgramFilterDTO.prototype, "longitude", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "useRadius", void 0);

__decorate([class_validator_1.IsBoolean(), class_validator_1.IsOptional(), __metadata("design:type", Boolean)], ProgramFilterDTO.prototype, "last24h", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "countryRegion", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "promoter", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ProgramFilterDTO.prototype, "closeTo", void 0);

exports.ProgramFilterDTO = ProgramFilterDTO;

var MinPriceByCityDTO = function MinPriceByCityDTO() {
  _classCallCheck(this, MinPriceByCityDTO);
};

exports.MinPriceByCityDTO = MinPriceByCityDTO;
var ProgramDeliveryEnum;

(function (ProgramDeliveryEnum) {
  ProgramDeliveryEnum["NOW"] = "now";
  ProgramDeliveryEnum["THIS_YEAR"] = "thisYear";
  ProgramDeliveryEnum["NEXT_YEAR"] = "nextYear";
  ProgramDeliveryEnum["AFTER_TWO_YEARS"] = "after2Years";
  ProgramDeliveryEnum["SOON"] = "soon";
})(ProgramDeliveryEnum = exports.ProgramDeliveryEnum || (exports.ProgramDeliveryEnum = {}));

var ProgramOrderEnum;

(function (ProgramOrderEnum) {
  ProgramOrderEnum["name"] = "program.name";
  ProgramOrderEnum["city"] = "program.city";
  ProgramOrderEnum["createDate"] = "program.createDate";
  ProgramOrderEnum["finishDate"] = "program.finishDate";
  ProgramOrderEnum["price"] = "minPrice";
  ProgramOrderEnum["liveSelection"] = "liveSelection";
  ProgramOrderEnum["random"] = "random";
})(ProgramOrderEnum = exports.ProgramOrderEnum || (exports.ProgramOrderEnum = {}));

var ProgramTags;

(function (ProgramTags) {
  ProgramTags["liveSelection"] = "S\xE9lection du mois (Habiter)";
  ProgramTags["investSelection"] = "S\xE9lection du mois (Investir)";
  ProgramTags["reducedVat"] = "TVA r\xE9duite";
  ProgramTags["closeToParis"] = "A moins de 30 min de Paris";
  ProgramTags["pinel"] = "Top Pinel";
  ProgramTags["profitability"] = "Top rentabilit\xE9";
  ProgramTags["greaterParis"] = "Top Grand Paris";
})(ProgramTags = exports.ProgramTags || (exports.ProgramTags = {}));

var ProgramPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(ProgramPaginationResponse, _pagination_1$Paginat);

  function ProgramPaginationResponse() {
    _classCallCheck(this, ProgramPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgramPaginationResponse).apply(this, arguments));
  }

  return ProgramPaginationResponse;
}(pagination_1.PaginationResponse);

exports.ProgramPaginationResponse = ProgramPaginationResponse;